module.exports = __webpack_public_path__ + "static/media/fi.21ff7a4f.svg";